import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';

class CalendarMonthNew extends React.Component {
  constructor(props) {
    super(props);

    this.handleMonthClick = this.handleMonthClick.bind(this);
  }

  handleMonthClick(e, month) {
    let newDate = this.props.data.displayDate;
    newDate.setDate(1); // 日付オーバーフロー防止に1日にリセット
    newDate.setMonth(month.getMonth());
    const newTerm = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}`;
    if (this.props.data.isNohinCalendar) {
      // 納品時期カレンダーの場合
      this.props.comactions.changeCalendarViewMode('day');
    } else {
      // 期間カレンダーの場合
      if (this.props.data.kikanUnit === 'days' || this.props.data.kikanUnit === 'weeks') {
        // viewModeをdayに切替
        this.props.comactions.changeCalendarViewMode('day');
      } else if (this.props.data.kikanUnit === 'months') {
        // 期間を選択してカレンダーを閉じる
        const termFromToMap = commonLogic.formatTermStartEndById(newTerm, this.props.data.kikanUnit);
        const termStart = termFromToMap.fromDate;
        const termEnd = termFromToMap.toDate;
        if (this.props.isExec) {
          this.props.comactions.changeKikanTerm(newTerm, termStart, termEnd, newDate);
        } else {
          // 画面リロードしない場合はカレンダーを閉じる
          this.props.handleCancel(e);
        }
      }
    }
  }

  render() {
    const currentDate = this.props.data.displayDate;
    let term;
    if (this.props.data.isNohinCalendar) {
      term = new Date(this.props.data.nohinTermData.data[0].model.nohinkaishibi);
    } else {
      if (this.props.data.kikanUnit == 'weeks') {
        let termDataIndex = this.props.data.termData.findIndex(item => item.id == this.props.data.term);
        if (termDataIndex == 0) {
          term = new Date(this.props.data.termData[0].from_date);
        } else {
          let weekValues = commonLogic.getWeekStartAndEnd(this.props.data.term, 7, 3);
          term = new Date(weekValues[weekValues.length - 1]);
        }
      } else {
        term = commonLogic.formatTermToDate(this.props.data.term, this.props.data.calendarViewMode, this.props.data.kikanUnit, this.props.data.termData);
      }
    }
    if (currentDate) {
      const months = Array.from({ length: 12 }, (_, i) => new Date(currentDate.getFullYear(), i));
      const termDataList = this.props.data.termData;
      const isCalendarViewModeHeaderEvent = this.props.data.isCalendarViewModeHeaderEvent;
      const kikanUnit = this.props.data.kikanUnit;
      const currentNohinTerm = this.props.data.isFromDatePicker ? this.props.data.nohinkaishibiFrom : this.props.data.nohinkaishibiTo;
      let currentNohinDate = null;

      if (currentNohinTerm != null && currentNohinTerm != undefined && currentNohinTerm != '') {
        currentNohinDate = new Date(currentNohinTerm);
      }

      const Nodes = months.map((month) => {
        let className = '';
        let canSelect = false;
        let isSelected = false;
        if (this.props.data.isNohinCalendar) {
          // 納品時期カレンダーの場合
          const nohinData = this.props.data.nohinTermData;
          const recentNohinDate =  new Date(nohinData.data[0].model.nohinkaishibi);
          const yearMonthA = recentNohinDate.getFullYear() * 100 + recentNohinDate.getMonth();
          const yearMonthB = month.getFullYear() * 100 + month.getMonth(); // YYYYMM形式

          canSelect = currentDate.getFullYear() >= 2010 && yearMonthA >= yearMonthB;

          if (currentNohinDate != null) {
            isSelected = currentNohinDate.getFullYear() == month.getFullYear() && currentNohinDate.getMonth() == month.getMonth();
          }
        } else {
          // 期間カレンダーの場合
          if (isCalendarViewModeHeaderEvent) {
            // カレンダーUIのヘッダから表示された場合
            canSelect = termDataList.some((item) => {
              let itemDate;
              let flg;
              if (kikanUnit == 'days') {
                itemDate = new Date(commonLogic.formatDate(item.id, 3));
                flg = (itemDate.getFullYear() == month.getFullYear() && itemDate.getMonth() == month.getMonth());
              } else if (kikanUnit == 'weeks') {
                let weekRangeList = commonLogic.getWeekStartAndEnd(item.id, 7, 3);
                let ymdFrom = weekRangeList[0];
                let ymdTo = weekRangeList[weekRangeList.length - 1];
                let itemDateFrom = new Date(ymdFrom);
                let itemDateTo = new Date(ymdTo);
                flg = (itemDateFrom.getFullYear() == month.getFullYear() && itemDateFrom.getMonth() == month.getMonth()) || (itemDateTo.getFullYear() == month.getFullYear() && itemDateTo.getMonth() == month.getMonth());
              } else {
                itemDate = new Date(item.id);
                flg = (itemDate.getFullYear() == month.getFullYear() && itemDate.getMonth() == month.getMonth());
              }

              return flg;
            });
          } else {
            // 絞り込み条件から表示された場合
            let targetTermId = commonLogic.formatDate(commonLogic.toLocaleString(month).replaceAll('/', '-'), 1);
            canSelect = termDataList.some(item => item.id == targetTermId);
          }

          isSelected = (month.getFullYear() === term.getFullYear() && month.getMonth() === term.getMonth());
        }

        if (!canSelect) {
          className += 'no_data';
        } else if (isSelected) {
          className += 'selected';
        }

        return (
          <div key={month} className={className}
            onClick={canSelect ? e => this.handleMonthClick(e, month) : null}
          >
            {month.getMonth() + 1}月
          </div>
        );
      });

      return  (
        <div className="date-picker-months">
          {Nodes}
        </div>
      );
    }
  }
}

CalendarMonthNew.propTypes = {
  data: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  isExec: PropTypes.any.isRequired
};

export default CalendarMonthNew;
